export function simulateMatchExpressionExhaustiveness(value: never): never {
    throw new Error(`Unhandled case: ${String(value)}`)
}
